
 
// 引入VueRouter
import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
//引入组件
// import login from '../views/login';
// import home from '../pages/Home/index';
 
//创建router实例对象，去管理一组一组的路由规则
const routes = [
    {
      path: "/",
      name: "index",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/index.vue"),
    },
	{
	  path: "/home",
	  name: "home",
	  component: () =>
	    import(/* webpackChunkName: "about" */ "../views/Home/myHome.vue"),
	},
	{
	  path: "/homeEn",
	  name: "homeEn",
	  component: () =>
	    import(/* webpackChunkName: "about" */ "../views/Home/myHomeEn.vue"),
	},
    {
      path: "/list",
      name: "list",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/List/myList1.vue"),
    },
	{
	  path: "/listEn",
	  name: "listEn",
	  component: () =>
	    import(/* webpackChunkName: "about" */ "../views/List/myList1En.vue"),
	}
]
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });
  
  export default router;